import React from "react";
import Image from "react-bootstrap/Image";
import logo from "assets/images/cap60.png";
function Logo() {
  return (
    <div>
      <Image src={logo} height={55} />
    </div>
  );
}

export default Logo;
